import React from "react";

import { cn } from "@/app/handlers/cn.utils";

type BulkFitCheckStep = "SELECT_JOBS" | "SELECT_DSP" | "CONFIRM" | "LOADING" | "COMPLETE";

interface ProgressDotsProps {
	currentStep: BulkFitCheckStep;
}

export const ProgressDots = ({ currentStep }: ProgressDotsProps) => {
	const steps: BulkFitCheckStep[] = ["SELECT_JOBS", "SELECT_DSP", "CONFIRM"];
	const currentIndex = steps.indexOf(currentStep);

	return (
		<div className="flex items-center gap-1">
			{steps.map((step, index) => (
				<div
					key={step}
					className={cn("w-2 h-2 rounded-full transition-all", {
						"w-5 bg-blue-500": index === currentIndex,
						"bg-blue-500": index < currentIndex,
						"bg-gray-300": index > currentIndex,
					})}
				/>
			))}
		</div>
	);
};

export default ProgressDots;
